// 娱乐明星关键词库，用于明星热搜识别
// 按类别分组：歌手、演员、综艺人、体育明星等

export interface Celebrity {
  name: string;           // 明星姓名
  aliases: string[];      // 别名/艺名/昵称
  category: "歌手" | "演员" | "综艺人" | "体育明星" | "主持人" | "导演" | "网红" | "其他";
  gender: "男" | "女" | "未知";
}

// 歌手
const singers: Celebrity[] = [
  { name: "周杰伦", aliases: ["Jay", "周董", "杰伦"], category: "歌手", gender: "男" },
  { name: "林俊杰", aliases: ["JJ"], category: "歌手", gender: "男" },
  { name: "薛之谦", aliases: ["谦谦", "老薛"], category: "歌手", gender: "男" },
  { name: "李荣浩", aliases: [], category: "歌手", gender: "男" },
  { name: "毛不易", aliases: ["毛毛"], category: "歌手", gender: "男" },
  { name: "华晨宇", aliases: ["花花"], category: "歌手", gender: "男" },
  { name: "张艺兴", aliases: ["Lay", "小绵羊"], category: "歌手", gender: "男" },
  { name: "王源", aliases: [], category: "歌手", gender: "男" },
  { name: "王俊凯", aliases: ["凯凯", "小凯"], category: "歌手", gender: "男" },
  { name: "易烊千玺", aliases: ["四字弟弟", "千玺"], category: "歌手", gender: "男" },
  { name: "鹿晗", aliases: [], category: "歌手", gender: "男" },
  { name: "黄子韬", aliases: ["韬韬"], category: "歌手", gender: "男" },
  { name: "吴亦凡", aliases: ["凡凡", "Kris"], category: "歌手", gender: "男" },
  { name: "蔡徐坤", aliases: ["坤坤"], category: "歌手", gender: "男" },
  { name: "肖战", aliases: [], category: "歌手", gender: "男" },
  { name: "王一博", aliases: ["耶啵"], category: "歌手", gender: "男" },
  { name: "张杰", aliases: [], category: "歌手", gender: "男" },
  { name: "周深", aliases: ["深深", "卡布叻"], category: "歌手", gender: "男" },
  { name: "许嵩", aliases: ["Vae"], category: "歌手", gender: "男" },
  { name: "汪苏泷", aliases: ["泷泷"], category: "歌手", gender: "男" },
  { name: "陈奕迅", aliases: ["Eason", "医生"], category: "歌手", gender: "男" },
  { name: "王力宏", aliases: ["Leehom"], category: "歌手", gender: "男" },
  { name: "五月天", aliases: ["Mayday", "阿信", "五月天阿信"], category: "歌手", gender: "男" },
  { name: "邓紫棋", aliases: ["G.E.M.", "GEM", "紫棋", "邓诗颖"], category: "歌手", gender: "女" },
  { name: "张靓颖", aliases: ["Jane", "珍姐"], category: "歌手", gender: "女" },
  { name: "王菲", aliases: ["天后"], category: "歌手", gender: "女" },
  { name: "那英", aliases: [], category: "歌手", gender: "女" },
  { name: "韩红", aliases: [], category: "歌手", gender: "女" },
  { name: "李宇春", aliases: ["春春"], category: "歌手", gender: "女" },
  { name: "周笔畅", aliases: ["笔笔"], category: "歌手", gender: "女" },
  { name: "张惠妹", aliases: ["阿妹", "阿密特"], category: "歌手", gender: "女" },
  { name: "蔡依林", aliases: ["Jolin", "公主"], category: "歌手", gender: "女" },
  { name: "萧亚轩", aliases: ["Elva"], category: "歌手", gender: "女" },
  { name: "王心凌", aliases: ["甜心教主"], category: "歌手", gender: "女" },
  { name: "杨丞琳", aliases: ["Rainie"], category: "歌手", gender: "女" },
  { name: "张韶涵", aliases: ["Angela"], category: "歌手", gender: "女" },
  { name: "田馥甄", aliases: ["Hebe"], category: "歌手", gender: "女" },
  { name: "陈嘉桦", aliases: ["Ella"], category: "歌手", gender: "女" },
  { name: "任家萱", aliases: ["Selina"], category: "歌手", gender: "女" },
  { name: "刘雨昕", aliases: [], category: "歌手", gender: "女" },
  { name: "虞书欣", aliases: ["欣欣子"], category: "歌手", gender: "女" },
  { name: "杨超越", aliases: ["超越妹妹", "锦鲤"], category: "歌手", gender: "女" },
  { name: "吴宣仪", aliases: [], category: "歌手", gender: "女" },
  { name: "孟美岐", aliases: ["山支大哥"], category: "歌手", gender: "女" },
  { name: "程潇", aliases: [], category: "歌手", gender: "女" },
  { name: "周洁琼", aliases: [], category: "歌手", gender: "女" },
  { name: "鞠婧祎", aliases: ["四千年美女", "小鞠"], category: "歌手", gender: "女" },
  { name: "李沁", aliases: [], category: "歌手", gender: "女" },
];

// 演员
const actors: Celebrity[] = [
  { name: "成龙", aliases: ["Jackie Chan", "大哥"], category: "演员", gender: "男" },
  { name: "周润发", aliases: ["发哥"], category: "演员", gender: "男" },
  { name: "刘德华", aliases: ["华仔", "Andy"], category: "演员", gender: "男" },
  { name: "梁朝伟", aliases: ["Tony"], category: "演员", gender: "男" },
  { name: "周星驰", aliases: ["星爷", "星仔"], category: "演员", gender: "男" },
  { name: "黄渤", aliases: [], category: "演员", gender: "男" },
  { name: "徐峥", aliases: ["山争哥哥"], category: "演员", gender: "男" },
  { name: "吴京", aliases: [], category: "演员", gender: "男" },
  { name: "沈腾", aliases: ["沈叔叔"], category: "演员", gender: "男" },
  { name: "王宝强", aliases: ["宝宝"], category: "演员", gender: "男" },
  { name: "邓超", aliases: ["超哥"], category: "演员", gender: "男" },
  { name: "黄晓明", aliases: ["晓明哥", "教主"], category: "演员", gender: "男" },
  { name: "陈坤", aliases: ["厂花"], category: "演员", gender: "男" },
  { name: "胡歌", aliases: ["老胡", "胡老大"], category: "演员", gender: "男" },
  { name: "霍建华", aliases: ["华哥", "老干部"], category: "演员", gender: "男" },
  { name: "靳东", aliases: ["老干部", "东哥"], category: "演员", gender: "男" },
  { name: "雷佳音", aliases: ["雷子", "大头"], category: "演员", gender: "男" },
  { name: "李现", aliases: ["现男友"], category: "演员", gender: "男" },
  { name: "邓伦", aliases: [], category: "演员", gender: "男" },
  { name: "杨洋", aliases: [], category: "演员", gender: "男" },
  { name: "李易峰", aliases: ["峰峰"], category: "演员", gender: "男" },
  { name: "朱一龙", aliases: ["龙哥"], category: "演员", gender: "男" },
  { name: "白宇", aliases: [], category: "演员", gender: "男" },
  { name: "张若昀", aliases: [], category: "演员", gender: "男" },
  { name: "张颂文", aliases: [], category: "演员", gender: "男" },
  { name: "井柏然", aliases: [], category: "演员", gender: "男" },
  { name: "林更新", aliases: ["林狗", "更新"], category: "演员", gender: "男" },
  { name: "郑恺", aliases: ["小猎豹"], category: "演员", gender: "男" },
  { name: "陈赫", aliases: ["赤赤"], category: "演员", gender: "男" },
  { name: "李晨", aliases: ["大黑牛"], category: "演员", gender: "男" },
  { name: "鹿晗", aliases: [], category: "演员", gender: "男" },
  { name: "黄子韬", aliases: [], category: "演员", gender: "男" },
  { name: "张艺兴", aliases: [], category: "演员", gender: "男" },
  { name: "龚俊", aliases: [], category: "演员", gender: "男" },
  { name: "张哲瀚", aliases: [], category: "演员", gender: "男" },
  { name: "许凯", aliases: [], category: "演员", gender: "男" },
  { name: "罗云熙", aliases: ["云熙", "润玉"], category: "演员", gender: "男" },
  { name: "成毅", aliases: [], category: "演员", gender: "男" },
  { name: "王鹤棣", aliases: [], category: "演员", gender: "男" },
  { name: "檀健次", aliases: [], category: "演员", gender: "男" },
  { name: "陈哲远", aliases: [], category: "演员", gender: "男" },
  { name: "于适", aliases: [], category: "演员", gender: "男" },
  { name: "此沙", aliases: [], category: "演员", gender: "男" },
  { name: "侯雯元", aliases: [], category: "演员", gender: "男" },
  { name: "黄曦彦", aliases: [], category: "演员", gender: "男" },
  { name: "刘昊然", aliases: ["昊然弟弟", "弟弟"], category: "演员", gender: "男" },
  { name: "吴磊", aliases: ["三石弟弟", "磊磊"], category: "演员", gender: "男" },
  { name: "彭昱畅", aliases: ["彭彭"], category: "演员", gender: "男" },
  { name: "胡先煦", aliases: [], category: "演员", gender: "男" },
  { name: "张子枫", aliases: ["子枫妹妹", "枫枫"], category: "演员", gender: "女" },
  { name: "文淇", aliases: [], category: "演员", gender: "女" },
  { name: "赵今麦", aliases: [], category: "演员", gender: "女" },
  { name: "蒋依依", aliases: [], category: "演员", gender: "女" },
  { name: "杨幂", aliases: ["大幂幂", "幂幂", "杨函数"], category: "演员", gender: "女" },
  { name: "赵丽颖", aliases: ["颖宝", "小骨"], category: "演员", gender: "女" },
  { name: "刘诗诗", aliases: ["诗诗", "诗爷"], category: "演员", gender: "女" },
  { name: "唐嫣", aliases: ["糖糖", "糖嫣"], category: "演员", gender: "女" },
  { name: "刘亦菲", aliases: ["神仙姐姐", "天仙", "菲菲"], category: "演员", gender: "女" },
  { name: "范冰冰", aliases: ["范爷", "冰冰", "范小胖"], category: "演员", gender: "女" },
  { name: "李冰冰", aliases: [], category: "演员", gender: "女" },
  { name: "周迅", aliases: ["周公子"], category: "演员", gender: "女" },
  { name: "赵薇", aliases: ["薇薇"], category: "演员", gender: "女" },
  { name: "章子怡", aliases: ["国际章"], category: "演员", gender: "女" },
  { name: "汤唯", aliases: [], category: "演员", gender: "女" },
  { name: "高圆圆", aliases: ["圆圆"], category: "演员", gender: "女" },
  { name: "Angelababy", aliases: ["杨颖", "Baby", "大宝贝", "鼻姐", "angelababy"], category: "演员", gender: "女" },
  { name: "迪丽热巴", aliases: ["热巴", "胖迪", "迪迪"], category: "演员", gender: "女" },
  { name: "古力娜扎", aliases: ["娜扎"], category: "演员", gender: "女" },
  { name: "佟丽娅", aliases: ["丫丫"], category: "演员", gender: "女" },
  { name: "马思纯", aliases: ["纯纯"], category: "演员", gender: "女" },
  { name: "周冬雨", aliases: ["小黄鸭", "冬叔"], category: "演员", gender: "女" },
  { name: "杨紫", aliases: ["小猴紫", "紫妹"], category: "演员", gender: "女" },
  { name: "关晓彤", aliases: ["格格", "彤彤"], category: "演员", gender: "女" },
  { name: "白鹿", aliases: [], category: "演员", gender: "女" },
  { name: "赵露思", aliases: ["露思", "肉丝"], category: "演员", gender: "女" },
  { name: "虞书欣", aliases: [], category: "演员", gender: "女" },
  { name: "杨超越", aliases: [], category: "演员", gender: "女" },
  { name: "程潇", aliases: [], category: "演员", gender: "女" },
  { name: "鞠婧祎", aliases: [], category: "演员", gender: "女" },
  { name: "李沁", aliases: [], category: "演员", gender: "女" },
  { name: "谭松韵", aliases: ["松韵"], category: "演员", gender: "女" },
  { name: "毛晓彤", aliases: [], category: "演员", gender: "女" },
  { name: "乔欣", aliases: [], category: "演员", gender: "女" },
  { name: "金晨", aliases: ["大喜"], category: "演员", gender: "女" },
  { name: "宋茜", aliases: ["Victoria"], category: "演员", gender: "女" },
  { name: "张天爱", aliases: [], category: "演员", gender: "女" },
  { name: "姚晨", aliases: ["大姚"], category: "演员", gender: "女" },
  { name: "海清", aliases: [], category: "演员", gender: "女" },
  { name: "闫妮", aliases: [], category: "演员", gender: "女" },
  { name: "孙俪", aliases: ["娘娘"], category: "演员", gender: "女" },
  { name: "刘涛", aliases: ["涛姐", "总攻"], category: "演员", gender: "女" },
  { name: "蒋欣", aliases: ["华妃娘娘", "娘娘"], category: "演员", gender: "女" },
  { name: "杨紫", aliases: [], category: "演员", gender: "女" },
];

// 综艺人
const varietyStars: Celebrity[] = [
  { name: "何炅", aliases: ["何老师", "炅炅"], category: "主持人", gender: "男" },
  { name: "汪涵", aliases: ["涵哥"], category: "主持人", gender: "男" },
  { name: "谢娜", aliases: ["娜姐", "太阳女神"], category: "主持人", gender: "女" },
  { name: "吴昕", aliases: [], category: "主持人", gender: "女" },
  { name: "杜海涛", aliases: [], category: "主持人", gender: "男" },
  { name: "李维嘉", aliases: ["嘉哥"], category: "主持人", gender: "男" },
  { name: "撒贝宁", aliases: ["撒老师", "小撒"], category: "主持人", gender: "男" },
  { name: "尼格买提", aliases: ["小尼"], category: "主持人", gender: "男" },
  { name: "康辉", aliases: [], category: "主持人", gender: "男" },
  { name: "董卿", aliases: [], category: "主持人", gender: "女" },
  { name: "李思思", aliases: [], category: "主持人", gender: "女" },
  { name: "华少", aliases: [], category: "主持人", gender: "男" },
  { name: "朱丹", aliases: [], category: "主持人", gender: "女" },
  { name: "沈梦辰", aliases: [], category: "主持人", gender: "女" },
  { name: "梁田", aliases: [], category: "主持人", gender: "女" },
  { name: "刘烨", aliases: [], category: "主持人", gender: "女" },
  { name: "靳梦佳", aliases: [], category: "主持人", gender: "女" },
  { name: "李莎旻子", aliases: [], category: "主持人", gender: "女" },
  { name: "齐思钧", aliases: [], category: "主持人", gender: "男" },
  { name: "吴泽林", aliases: [], category: "主持人", gender: "男" },
  { name: "张大大", aliases: [], category: "主持人", gender: "男" },
  { name: "杨迪", aliases: ["迪哥", "表情帝"], category: "综艺人", gender: "男" },
  { name: "贾玲", aliases: [], category: "综艺人", gender: "女" },
  { name: "沈腾", aliases: [], category: "综艺人", gender: "男" },
  { name: "马丽", aliases: [], category: "演员", gender: "女" },
  { name: "常远", aliases: [], category: "演员", gender: "男" },
  { name: "艾伦", aliases: [], category: "演员", gender: "男" },
  { name: "魏翔", aliases: [], category: "演员", gender: "男" },
  { name: "沙溢", aliases: ["老沙"], category: "演员", gender: "男" },
  { name: "李晨", aliases: [], category: "演员", gender: "男" },
  { name: "郑恺", aliases: [], category: "演员", gender: "男" },
  { name: "陈赫", aliases: [], category: "演员", gender: "男" },
  { name: "王祖蓝", aliases: [], category: "综艺人", gender: "男" },
  { name: "鹿晗", aliases: [], category: "歌手", gender: "男" },
  { name: "邓超", aliases: [], category: "演员", gender: "男" },
  { name: "孙俪", aliases: [], category: "演员", gender: "女" },
  { name: "大张伟", aliases: ["大老师"], category: "歌手", gender: "男" },
  { name: "薛之谦", aliases: [], category: "歌手", gender: "男" },
  { name: "刘维", aliases: [], category: "歌手", gender: "男" },
  { name: "戚薇", aliases: ["七哥"], category: "歌手", gender: "女" },
  { name: "李承铉", aliases: [], category: "歌手", gender: "男" },
  { name: "应采儿", aliases: [], category: "演员", gender: "女" },
  { name: "陈小春", aliases: ["山鸡哥"], category: "歌手", gender: "男" },
  { name: "张智霖", aliases: ["Chilam"], category: "演员", gender: "男" },
  { name: "袁咏仪", aliases: ["靓靓"], category: "演员", gender: "女" },
  { name: "蔡少芬", aliases: ["Ada", "娘娘"], category: "演员", gender: "女" },
  { name: "张晋", aliases: [], category: "演员", gender: "男" },
  { name: "赵文卓", aliases: [], category: "演员", gender: "男" },
  { name: "林志炫", aliases: [], category: "歌手", gender: "男" },
  { name: "言承旭", aliases: ["Jerry"], category: "演员", gender: "男" },
  { name: "周渝民", aliases: ["仔仔"], category: "演员", gender: "男" },
  { name: "吴建豪", aliases: ["Vanness"], category: "歌手", gender: "男" },
  { name: "朱孝天", aliases: [], category: "演员", gender: "男" },
];

// 体育明星
const athletes: Celebrity[] = [
  { name: "姚明", aliases: ["大姚", "明哥"], category: "体育明星", gender: "男" },
  { name: "刘翔", aliases: ["飞人"], category: "体育明星", gender: "男" },
  { name: "李娜", aliases: [], category: "体育明星", gender: "女" },
  { name: "孙杨", aliases: ["大白杨"], category: "体育明星", gender: "男" },
  { name: "宁泽涛", aliases: [], category: "体育明星", gender: "男" },
  { name: "傅园慧", aliases: ["洪荒少女"], category: "体育明星", gender: "女" },
  { name: "张继科", aliases: ["藏獒"], category: "体育明星", gender: "男" },
  { name: "马龙", aliases: ["龙队", "六边形战士"], category: "体育明星", gender: "男" },
  { name: "许昕", aliases: ["大蟒", "昕爷"], category: "体育明星", gender: "男" },
  { name: "樊振东", aliases: ["小胖"], category: "体育明星", gender: "男" },
  { name: "王楚钦", aliases: ["大头"], category: "体育明星", gender: "男" },
  { name: "孙颖莎", aliases: ["莎莎", "小魔王"], category: "体育明星", gender: "女" },
  { name: "陈梦", aliases: [], category: "体育明星", gender: "女" },
  { name: "王曼昱", aliases: [], category: "体育明星", gender: "女" },
  { name: "刘诗雯", aliases: ["小枣"], category: "体育明星", gender: "女" },
  { name: "丁宁", aliases: [], category: "体育明星", gender: "女" },
  { name: "邓亚萍", aliases: [], category: "体育明星", gender: "女" },
  { name: "王楠", aliases: [], category: "体育明星", gender: "女" },
  { name: "张怡宁", aliases: ["大魔王"], category: "体育明星", gender: "女" },
  { name: "刘国梁", aliases: ["刘指导", "不懂球的胖子"], category: "体育明星", gender: "男" },
  { name: "孔令辉", aliases: [], category: "体育明星", gender: "男" },
  { name: "林丹", aliases: ["超级丹"], category: "体育明星", gender: "男" },
  { name: "谌龙", aliases: [], category: "体育明星", gender: "男" },
  { name: "李宗伟", aliases: [], category: "体育明星", gender: "男" },
  { name: "C罗", aliases: ["Cristiano Ronaldo", "罗纳尔多", "总裁", "小小罗"], category: "体育明星", gender: "男" },
  { name: "梅西", aliases: ["Lionel Messi", "梅球王", "煤球王", "Messi"], category: "体育明星", gender: "男" },
  { name: "内马尔", aliases: ["Neymar", "内少"], category: "体育明星", gender: "男" },
  { name: "姆巴佩", aliases: ["Kylian Mbappé", "神龟"], category: "体育明星", gender: "男" },
  { name: "哈兰德", aliases: ["Erling Haaland", "魔人布欧"], category: "体育明星", gender: "男" },
  { name: "詹姆斯", aliases: ["LeBron James", "老詹", "LBJ", "詹皇"], category: "体育明星", gender: "男" },
  { name: "库里", aliases: ["Stephen Curry", "萌神", "小学生"], category: "体育明星", gender: "男" },
  { name: "杜兰特", aliases: ["Kevin Durant", "KD", "死神"], category: "体育明星", gender: "男" },
  { name: "哈登", aliases: ["James Harden", "大胡子"], category: "体育明星", gender: "男" },
  { name: "威少", aliases: ["Russell Westbrook", "神龟"], category: "体育明星", gender: "男" },
  { name: "欧文", aliases: ["Kyrie Irving", "德鲁大叔"], category: "体育明星", gender: "男" },
  { name: "字母哥", aliases: ["Giannis Antetokounmpo", "希腊怪兽"], category: "体育明星", gender: "男" },
  { name: "东契奇", aliases: ["Luka Dončić", "077", "胖七七"], category: "体育明星", gender: "男" },
  { name: "约基奇", aliases: ["Nikola Jokić", "小丑", "五花肉"], category: "体育明星", gender: "男" },
  { name: "塔图姆", aliases: ["Jayson Tatum", "獭兔"], category: "体育明星", gender: "男" },
  { name: "巴特勒", aliases: ["Jimmy Butler", "JB", "硬汉"], category: "体育明星", gender: "男" },
  { name: "伦纳德", aliases: ["Kawhi Leonard", "卡哇伊", "小卡", "机器人"], category: "体育明星", gender: "男" },
  { name: "乔治", aliases: ["Paul George", "泡椒"], category: "体育明星", gender: "男" },
  { name: "恩比德", aliases: ["Joel Embiid", "大帝", "过程"], category: "体育明星", gender: "男" },
  { name: "戴维斯", aliases: ["Anthony Davis", "浓眉"], category: "体育明星", gender: "男" },
  { name: "科比", aliases: ["Kobe Bryant", "黑曼巴", "小飞侠", "蜗壳", "科神"], category: "体育明星", gender: "男" },
  { name: "乔丹", aliases: ["Michael Jordan", "MJ", "篮球之神", "飞人"], category: "体育明星", gender: "男" },
  { name: "奥尼尔", aliases: ["Shaquille O'Neal", "大鲨鱼", "沙克"], category: "体育明星", gender: "男" },
  { name: "艾弗森", aliases: ["Allen Iverson", "答案", "AI"], category: "体育明星", gender: "男" },
  { name: "麦迪", aliases: ["Tracy McGrady", "T-Mac", "麦迪"], category: "体育明星", gender: "男" },
  { name: "加内特", aliases: ["Kevin Garnett", "KG", "狼王", "硬特"], category: "体育明星", gender: "男" },
  { name: "诺维茨基", aliases: ["Dirk Nowitzki", "诺天王", "德国战车"], category: "体育明星", gender: "男" },
  { name: "邓肯", aliases: ["Tim Duncan", "石佛", "呆呆", "邓呆呆"], category: "体育明星", gender: "男" },
  { name: "吉诺比利", aliases: ["Manu Ginobili", "妖刀", "马努"], category: "体育明星", gender: "男" },
  { name: "帕克", aliases: ["Tony Parker", "法国跑车", "TP"], category: "体育明星", gender: "男" },
  { name: "韦德", aliases: ["Dwyane Wade", "闪电侠", "DW", "腮帮侠"], category: "体育明星", gender: "男" },
  { name: "波什", aliases: ["Chris Bosh", "龙王", "CB"], category: "体育明星", gender: "男" },
  { name: "安东尼", aliases: ["Carmelo Anthony", "甜瓜", "Melo"], category: "体育明星", gender: "男" },
  { name: "罗斯", aliases: ["Derrick Rose", "风城玫瑰", "DR"], category: "体育明星", gender: "男" },
  { name: "霍华德", aliases: ["Dwight Howard", "魔兽", "火花", "快乐兽"], category: "体育明星", gender: "男" },
  { name: "保罗", aliases: ["Chris Paul", "CP3", "控卫之神", "炮"], category: "体育明星", gender: "男" },
  { name: "纳什", aliases: ["Steve Nash", "风之子"], category: "体育明星", gender: "男" },
  { name: "基德", aliases: ["Jason Kidd", "JK"], category: "体育明星", gender: "男" },
  { name: "卡特", aliases: ["Vince Carter", "UFO", "半人半神", "VC"], category: "体育明星", gender: "男" },
  { name: "皮尔斯", aliases: ["Paul Pierce", "真理", "PP"], category: "体育明星", gender: "男" },
  { name: "雷阿伦", aliases: ["Ray Allen", "君子雷", "耶稣射"], category: "体育明星", gender: "男" },
  { name: "加内特", aliases: [], category: "体育明星", gender: "男" },
  { name: "谷爱凌", aliases: ["Eileen Gu", "青蛙公主"], category: "体育明星", gender: "女" },
  { name: "苏翊鸣", aliases: [], category: "体育明星", gender: "男" },
  { name: "武大靖", aliases: [], category: "体育明星", gender: "男" },
  { name: "任子威", aliases: [], category: "体育明星", gender: "男" },
  { name: "李文龙", aliases: [], category: "体育明星", gender: "男" },
  { name: "徐梦桃", aliases: [], category: "体育明星", gender: "女" },
  { name: "齐广璞", aliases: [], category: "体育明星", gender: "男" },
  { name: "贾宗洋", aliases: [], category: "体育明星", gender: "男" },
  { name: "隋文静", aliases: [], category: "体育明星", gender: "女" },
  { name: "韩聪", aliases: [], category: "体育明星", gender: "男" },
  { name: "彭程", aliases: [], category: "体育明星", gender: "女" },
  { name: "金杨", aliases: [], category: "体育明星", gender: "男" },
  { name: "王诗玥", aliases: [], category: "体育明星", gender: "女" },
  { name: "柳鑫宇", aliases: [], category: "体育明星", gender: "男" },
  { name: "全红婵", aliases: ["婵宝"], category: "体育明星", gender: "女" },
  { name: "陈芋汐", aliases: [], category: "体育明星", gender: "女" },
  { name: "张家齐", aliases: [], category: "体育明星", gender: "女" },
  { name: "任茜", aliases: [], category: "体育明星", gender: "女" },
  { name: "曹缘", aliases: [], category: "体育明星", gender: "男" },
  { name: "陈艾森", aliases: [], category: "体育明星", gender: "男" },
  { name: "杨健", aliases: [], category: "体育明星", gender: "男" },
  { name: "王宗源", aliases: [], category: "体育明星", gender: "男" },
  { name: "谢思埸", aliases: [], category: "体育明星", gender: "男" },
  { name: "施廷懋", aliases: [], category: "体育明星", gender: "女" },
  { name: "王涵", aliases: [], category: "体育明星", gender: "女" },
  { name: "刘湘", aliases: [], category: "体育明星", gender: "女" },
  { name: "傅园慧", aliases: [], category: "体育明星", gender: "女" },
  { name: "叶诗文", aliases: [], category: "体育明星", gender: "女" },
  { name: "汪顺", aliases: [], category: "体育明星", gender: "男" },
  { name: "徐嘉余", aliases: [], category: "体育明星", gender: "男" },
  { name: "闫子贝", aliases: [], category: "体育明星", gender: "男" },
  { name: "李冰洁", aliases: [], category: "体育明星", gender: "女" },
  { name: "汤慕涵", aliases: [], category: "体育明星", gender: "女" },
  { name: "张雨霏", aliases: [], category: "体育明星", gender: "女" },
  { name: "杨浚瑄", aliases: [], category: "体育明星", gender: "女" },
  { name: "吴卿风", aliases: [], category: "体育明星", gender: "女" },
  { name: "程玉洁", aliases: [], category: "体育明星", gender: "女" },
  { name: "朱梦惠", aliases: [], category: "体育明星", gender: "女" },
  { name: "艾衍含", aliases: [], category: "体育明星", gender: "女" },
  { name: "孙佳俊", aliases: [], category: "体育明星", gender: "男" },
  { name: "覃海洋", aliases: [], category: "体育明星", gender: "男" },
  { name: "潘展乐", aliases: [], category: "体育明星", gender: "男" },
  { name: "费立纬", aliases: [], category: "体育明星", gender: "男" },
  { name: "王长浩", aliases: [], category: "体育明星", gender: "男" },
  { name: "陈俊儿", aliases: [], category: "体育明星", gender: "男" },
  { name: "洪金权", aliases: [], category: "体育明星", gender: "男" },
];

// 导演
const directors: Celebrity[] = [
  { name: "张艺谋", aliases: ["国师", "老谋子"], category: "导演", gender: "男" },
  { name: "陈凯歌", aliases: [], category: "导演", gender: "男" },
  { name: "冯小刚", aliases: ["冯导", "小刚", "冯裤子"], category: "导演", gender: "男" },
  { name: "姜文", aliases: [], category: "导演", gender: "男" },
  { name: "贾樟柯", aliases: [], category: "导演", gender: "男" },
  { name: "王小帅", aliases: [], category: "导演", gender: "男" },
  { name: "陆川", aliases: [], category: "导演", gender: "男" },
  { name: "宁浩", aliases: [], category: "导演", gender: "男" },
  { name: "徐峥", aliases: [], category: "导演", gender: "男" },
  { name: "陈思诚", aliases: [], category: "导演", gender: "男" },
  { name: "吴京", aliases: [], category: "导演", gender: "男" },
  { name: "郭帆", aliases: [], category: "导演", gender: "男" },
  { name: "饺子", aliases: ["杨宇"], category: "导演", gender: "男" },
  { name: "文牧野", aliases: [], category: "导演", gender: "男" },
  { name: "闫非", aliases: [], category: "导演", gender: "男" },
  { name: "彭大魔", aliases: [], category: "导演", gender: "男" },
  { name: "韩寒", aliases: [], category: "导演", gender: "男" },
  { name: "郭敬明", aliases: ["小四"], category: "导演", gender: "男" },
  { name: "赵薇", aliases: [], category: "导演", gender: "女" },
  { name: "徐静蕾", aliases: ["老徐"], category: "导演", gender: "女" },
  { name: "李玉", aliases: [], category: "导演", gender: "女" },
  { name: "薛晓路", aliases: [], category: "导演", gender: "女" },
  { name: "张艾嘉", aliases: [], category: "导演", gender: "女" },
  { name: "许鞍华", aliases: [], category: "导演", gender: "女" },
  { name: "王家卫", aliases: ["墨镜王", "Wong Kar-wai"], category: "导演", gender: "男" },
  { name: "周星驰", aliases: ["星爷", "Stephen Chow"], category: "导演", gender: "男" },
  { name: "刘伟强", aliases: [], category: "导演", gender: "男" },
  { name: "麦兆辉", aliases: [], category: "导演", gender: "男" },
  { name: "庄文强", aliases: [], category: "导演", gender: "男" },
  { name: "杜琪峰", aliases: [], category: "导演", gender: "男" },
  { name: "尔冬升", aliases: [], category: "导演", gender: "男" },
  { name: "林超贤", aliases: [], category: "导演", gender: "男" },
  { name: "郑保瑞", aliases: [], category: "导演", gender: "男" },
  { name: "叶伟信", aliases: [], category: "导演", gender: "男" },
  { name: "陈木胜", aliases: [], category: "导演", gender: "男" },
  { name: "邱礼涛", aliases: [], category: "导演", gender: "男" },
  { name: "韦家辉", aliases: [], category: "导演", gender: "男" },
];

// 网红
const influencers: Celebrity[] = [
  { name: "李子柒", aliases: [], category: "网红", gender: "女" },
  { name: "李佳琦", aliases: ["口红一哥"], category: "网红", gender: "男" },
  { name: "薇娅", aliases: [], category: "网红", gender: "女" },
  { name: "辛巴", aliases: [], category: "网红", gender: "男" },
  { name: "罗永浩", aliases: ["老罗", "罗老师"], category: "网红", gender: "男" },
  { name: "papi酱", aliases: ["姜逸磊"], category: "网红", gender: "女" },
  { name: "办公室小野", aliases: [], category: "网红", gender: "女" },
  { name: "代古拉K", aliases: [], category: "网红", gender: "女" },
  { name: "冯提莫", aliases: [], category: "网红", gender: "女" },
  { name: "刘宇宁", aliases: ["摩登兄弟"], category: "网红", gender: "男" },
  { name: "郭聪明", aliases: [], category: "网红", gender: "男" },
  { name: "高火火", aliases: [], category: "网红", gender: "男" },
  { name: "惠子", aliases: [], category: "网红", gender: "女" },
  { name: "唐艺", aliases: [], category: "网红", gender: "女" },
  { name: "胜仔", aliases: [], category: "网红", gender: "男" },
  { name: "小杨哥", aliases: ["疯狂小杨哥"], category: "网红", gender: "男" },
  { name: "大杨哥", aliases: [], category: "网红", gender: "男" },
  { name: "陈翔六点半", aliases: [], category: "网红", gender: "男" },
  { name: "毛毛姐", aliases: ["多余和毛毛姐"], category: "网红", gender: "男" },
  { name: "祝晓晗", aliases: [], category: "网红", gender: "女" },
  { name: "浪胃仙", aliases: [], category: "网红", gender: "未知" },
  { name: "张欣尧", aliases: [], category: "网红", gender: "男" },
  { name: "费启鸣", aliases: [], category: "网红", gender: "男" },
  { name: "斯外戈", aliases: [], category: "网红", gender: "男" },
  { name: "艾比", aliases: [], category: "网红", gender: "未知" },
  { name: "Abbily", aliases: [], category: "网红", gender: "未知" },
  { name: "韩美娟", aliases: [], category: "网红", gender: "男" },
  { name: "赤木刚宪", aliases: [], category: "网红", gender: "女" },
  { name: "刀小刀", aliases: [], category: "网红", gender: "女" },
  { name: "刘思瑶", aliases: [], category: "网红", gender: "女" },
  { name: "彭十六", aliases: [], category: "网红", gender: "女" },
  { name: "林一", aliases: [], category: "网红", gender: "男" },
  { name: "梅尼耶", aliases: [], category: "网红", gender: "男" },
  { name: "涂罗伊", aliases: [], category: "网红", gender: "女" },
  { name: "临界十缨", aliases: [], category: "网红", gender: "女" },
  { name: "罗西", aliases: [], category: "网红", gender: "男" },
  { name: "黄三斤", aliases: [], category: "网红", gender: "女" },
  { name: "爆胎草莓粥", aliases: [], category: "网红", gender: "女" },
  { name: "王不染", aliases: [], category: "网红", gender: "男" },
  { name: "井川里予", aliases: ["悲伤玉米排骨汤"], category: "网红", gender: "女" },
  { name: "易梦玲", aliases: [], category: "网红", gender: "女" },
  { name: "方圆", aliases: [], category: "网红", gender: "女" },
  { name: "何丹彤", aliases: [], category: "网红", gender: "女" },
  { name: "变装", aliases: [], category: "网红", gender: "未知" },
  { name: "垫底辣孩", aliases: [], category: "网红", gender: "男" },
  { name: "陆仙人", aliases: [], category: "网红", gender: "男" },
  { name: "张同学", aliases: [], category: "网红", gender: "男" },
  { name: "潘姥姥", aliases: [], category: "网红", gender: "女" },
  { name: "康仔农人", aliases: [], category: "网红", gender: "男" },
  { name: "蜀中桃子姐", aliases: [], category: "网红", gender: "女" },
  { name: "牛爱芳", aliases: [], category: "网红", gender: "未知" },
  { name: "小春花", aliases: [], category: "网红", gender: "女" },
  { name: "张踩铃", aliases: [], category: "网红", gender: "女" },
  { name: "傅首尔", aliases: [], category: "网红", gender: "女" },
  { name: "杨笠", aliases: [], category: "网红", gender: "女" },
  { name: "李雪琴", aliases: [], category: "网红", gender: "女" },
  { name: "王建国", aliases: [], category: "网红", gender: "男" },
  { name: "呼兰", aliases: [], category: "网红", gender: "男" },
  { name: "庞博", aliases: [], category: "网红", gender: "男" },
  { name: "周奇墨", aliases: [], category: "网红", gender: "男" },
  { name: "何广智", aliases: [], category: "网红", gender: "男" },
  { name: "徐志胜", aliases: [], category: "网红", gender: "男" },
  { name: "童漠男", aliases: [], category: "网红", gender: "男" },
  { name: "邱瑞", aliases: [], category: "网红", gender: "男" },
  { name: "鸟鸟", aliases: [], category: "网红", gender: "女" },
  { name: "颜怡颜悦", aliases: [], category: "网红", gender: "女" },
  { name: "小鹿", aliases: [], category: "网红", gender: "女" },
  { name: "步惊云", aliases: [], category: "网红", gender: "女" },
  { name: "杨蒙恩", aliases: [], category: "网红", gender: "男" },
  { name: "王勉", aliases: [], category: "网红", gender: "男" },
  { name: "豆豆", aliases: [], category: "网红", gender: "男" },
  { name: "小北", aliases: [], category: "网红", gender: "男" },
  { name: "House", aliases: [], category: "网红", gender: "男" },
  { name: "卡姆", aliases: [], category: "网红", gender: "男" },
  { name: "池子", aliases: [], category: "网红", gender: "男" },
  { name: "李诞", aliases: ["蛋总", "诞诞"], category: "网红", gender: "男" },
  { name: "王自健", aliases: [], category: "网红", gender: "男" },
  { name: "史炎", aliases: [], category: "网红", gender: "男" },
  { name: "Rock", aliases: [], category: "网红", gender: "男" },
  { name: "梁海源", aliases: [], category: "网红", gender: "男" },
  { name: "张博洋", aliases: [], category: "网红", gender: "男" },
  { name: "思文", aliases: [], category: "网红", gender: "女" },
  { name: "程璐", aliases: [], category: "网红", gender: "男" },
  { name: "梁欢", aliases: [], category: "网红", gender: "男" },
  { name: "刘旸教主", aliases: [], category: "网红", gender: "男" },
  { name: "鑫仔", aliases: [], category: "网红", gender: "男" },
  { name: "张哲华", aliases: [], category: "网红", gender: "男" },
  { name: "詹鑫", aliases: [], category: "网红", gender: "男" },
  { name: "刘波", aliases: [], category: "网红", gender: "男" },
  { name: "少爷和我", aliases: [], category: "网红", gender: "未知" },
  { name: "土豆", aliases: [], category: "网红", gender: "男" },
  { name: "吕严", aliases: [], category: "网红", gender: "男" },
  { name: "胖达人", aliases: [], category: "网红", gender: "未知" },
  { name: "蒋龙", aliases: [], category: "网红", gender: "男" },
  { name: "张弛", aliases: [], category: "网红", gender: "男" },
  { name: "逐梦亚军", aliases: [], category: "网红", gender: "未知" },
  { name: "大锁", aliases: [], category: "网红", gender: "男" },
  { name: "孙天宇", aliases: [], category: "网红", gender: "男" },
  { name: "天放", aliases: [], category: "网红", gender: "男" },
  { name: "酷酷的滕", aliases: [], category: "网红", gender: "男" },
  { name: "雷子", aliases: [], category: "网红", gender: "男" },
  { name: "苗若芃", aliases: [], category: "网红", gender: "男" },
  { name: "张呈", aliases: [], category: "网红", gender: "男" },
  { name: "九口人", aliases: [], category: "网红", gender: "未知" },
  { name: "某某某", aliases: [], category: "网红", gender: "未知" },
  { name: "左凌峰", aliases: [], category: "网红", gender: "男" },
  { name: "刘同", aliases: [], category: "网红", gender: "男" },
  { name: "张维伊", aliases: [], category: "网红", gender: "男" },
  { name: "小婉管乐", aliases: [], category: "网红", gender: "未知" },
  { name: "张小婉", aliases: [], category: "网红", gender: "女" },
  { name: "管乐", aliases: [], category: "网红", gender: "女" },
  { name: "阿奇与阿成", aliases: [], category: "网红", gender: "未知" },
  { name: "老师好", aliases: [], category: "网红", gender: "未知" },
  { name: "松天硕", aliases: [], category: "网红", gender: "男" },
  { name: "宇文秋实", aliases: [], category: "网红", gender: "男" },
  { name: "刘思维", aliases: [], category: "网红", gender: "男" },
  { name: "朱毅", aliases: [], category: "网红", gender: "男" },
  { name: "张祐维", aliases: [], category: "网红", gender: "男" },
  { name: "闫佩伦", aliases: [], category: "网红", gender: "男" },
  { name: "张踩铃", aliases: [], category: "网红", gender: "女" },
  { name: "李雪琴", aliases: [], category: "网红", gender: "女" },
  { name: "辣目洋子", aliases: ["李嘉琦"], category: "网红", gender: "女" },
  { name: "张欣尧", aliases: [], category: "网红", gender: "男" },
  { name: "井胧", aliases: [], category: "网红", gender: "男" },
  { name: "甘望星", aliases: [], category: "网红", gender: "男" },
  { name: "利路修", aliases: ["Lelush"], category: "网红", gender: "男" },
  { name: "韩佩泉", aliases: ["韩美娟"], category: "网红", gender: "男" },
  { name: "邵明明", aliases: [], category: "网红", gender: "男" },
  { name: "陆定昊", aliases: [], category: "网红", gender: "男" },
  { name: "王孝辰", aliases: [], category: "网红", gender: "男" },
  { name: "代少冬", aliases: [], category: "网红", gender: "男" },
  { name: "蒋敦豪", aliases: [], category: "网红", gender: "男" },
  { name: "吴宇恒", aliases: [], category: "网红", gender: "男" },
  { name: "井汲大翔", aliases: [], category: "网红", gender: "男" },
  { name: "庆怜", aliases: ["Caelan"], category: "网红", gender: "男" },
  { name: "米卡", aliases: ["Mika"], category: "网红", gender: "男" },
  { name: "赞多", aliases: ["Santa"], category: "网红", gender: "男" },
  { name: "力丸", aliases: ["Rikimaru"], category: "网红", gender: "男" },
  { name: "高卿尘", aliases: ["Nine"], category: "网红", gender: "男" },
  { name: "尹浩宇", aliases: ["Patrick"], category: "网红", gender: "男" },
  { name: "周柯宇", aliases: [], category: "网红", gender: "男" },
  { name: "刘彰", aliases: ["AK", "AK刘彰"], category: "网红", gender: "男" },
  { name: "林墨", aliases: [], category: "网红", gender: "男" },
  { name: "伯远", aliases: [], category: "网红", gender: "男" },
  { name: "张嘉元", aliases: [], category: "网红", gender: "男" },
  { name: "Patrick", aliases: [], category: "网红", gender: "男" },
  { name: "Nine", aliases: [], category: "网红", gender: "男" },
  { name: "Santa", aliases: [], category: "网红", gender: "男" },
  { name: "Rikimaru", aliases: [], category: "网红", gender: "男" },
  { name: "Mika", aliases: [], category: "网红", gender: "男" },
  { name: "Caelan", aliases: [], category: "网红", gender: "男" },
  { name: "Lelush", aliases: [], category: "网红", gender: "男" },
  { name: "INTO1", aliases: [], category: "网红", gender: "未知" },
  { name: "硬糖少女303", aliases: [], category: "网红", gender: "未知" },
  { name: "THE9", aliases: [], category: "网红", gender: "未知" },
  { name: "火箭少女101", aliases: [], category: "网红", gender: "未知" },
  { name: "R1SE", aliases: [], category: "网红", gender: "未知" },
  { name: "UNINE", aliases: [], category: "网红", gender: "未知" },
  { name: "IXFORM", aliases: [], category: "网红", gender: "未知" },
  { name: "SKY", aliases: [], category: "网红", gender: "未知" },
  { name: "S.K.Y", aliases: [], category: "网红", gender: "未知" },
  { name: "NAME", aliases: [], category: "网红", gender: "未知" },
  { name: "ENONE", aliases: [], category: "网红", gender: "未知" },
  { name: "BOYHOOD", aliases: [], category: "网红", gender: "未知" },
  { name: "Loong9", aliases: [], category: "网红", gender: "未知" },
  { name: "NexT", aliases: [], category: "网红", gender: "未知" },
  { name: "ONER", aliases: [], category: "网红", gender: "未知" },
  { name: "Awaken-F", aliases: [], category: "网红", gender: "未知" },
  { name: "TANGRAM", aliases: [], category: "网红", gender: "未知" },
  { name: "Mr.钛戈", aliases: [], category: "网红", gender: "未知" },
  { name: "沙漠五子", aliases: [], category: "网红", gender: "未知" },
  { name: "新风暴", aliases: [], category: "网红", gender: "未知" },
  { name: "Black ACE", aliases: [], category: "网红", gender: "未知" },
  { name: "以团之名", aliases: [], category: "网红", gender: "未知" },
  { name: "青春有你", aliases: [], category: "网红", gender: "未知" },
  { name: "创造营", aliases: [], category: "网红", gender: "未知" },
  { name: "创造101", aliases: [], category: "网红", gender: "未知" },
  { name: "创造2019", aliases: [], category: "网红", gender: "未知" },
  { name: "创造2020", aliases: [], category: "网红", gender: "未知" },
  { name: "创造2021", aliases: [], category: "网红", gender: "未知" },
  { name: "偶像练习生", aliases: [], category: "网红", gender: "未知" },
  { name: "少年之名", aliases: [], category: "网红", gender: "未知" },
  { name: "上线吧华彩少年", aliases: [], category: "网红", gender: "未知" },
  { name: "乘风破浪的姐姐", aliases: ["浪姐"], category: "网红", gender: "未知" },
  { name: "披荆斩棘的哥哥", aliases: ["披哥"], category: "网红", gender: "未知" },
  { name: "追光吧哥哥", aliases: [], category: "网红", gender: "未知" },
  { name: "明日之子", aliases: [], category: "网红", gender: "未知" },
  { name: "快乐男声", aliases: [], category: "网红", gender: "未知" },
  { name: "快乐女声", aliases: [], category: "网红", gender: "未知" },
  { name: "中国好声音", aliases: [], category: "网红", gender: "未知" },
  { name: "中国新说唱", aliases: [], category: "网红", gender: "未知" },
  { name: "说唱听我的", aliases: [], category: "网红", gender: "未知" },
  { name: "说唱新世代", aliases: [], category: "网红", gender: "未知" },
  { name: "黑怕女孩", aliases: [], category: "网红", gender: "未知" },
  { name: "乐队的夏天", aliases: ["乐夏"], category: "网红", gender: "未知" },
  { name: "我们的乐队", aliases: [], category: "网红", gender: "未知" },
  { name: "天赐的声音", aliases: [], category: "网红", gender: "未知" },
  { name: "歌手", aliases: [], category: "网红", gender: "未知" },
  { name: "我是歌手", aliases: [], category: "网红", gender: "未知" },
  { name: "蒙面唱将", aliases: [], category: "网红", gender: "未知" },
  { name: "梦想的声音", aliases: [], category: "网红", gender: "未知" },
  { name: "中国好歌曲", aliases: [], category: "网红", gender: "未知" },
  { name: "经典咏流传", aliases: [], category: "网红", gender: "未知" },
  { name: "国家宝藏", aliases: [], category: "网红", gender: "未知" },
  { name: "典籍里的中国", aliases: [], category: "网红", gender: "未知" },
  { name: "朗读者", aliases: [], category: "网红", gender: "未知" },
  { name: "见字如面", aliases: [], category: "网红", gender: "未知" },
  { name: "信中国", aliases: [], category: "网红", gender: "未知" },
  { name: "中国诗词大会", aliases: [], category: "网红", gender: "未知" },
  { name: "中国成语大会", aliases: [], category: "网红", gender: "未知" },
  { name: "中国汉字听写大会", aliases: [], category: "网红", gender: "未知" },
  { name: "一站到底", aliases: [], category: "网红", gender: "未知" },
  { name: "最强大脑", aliases: [], category: "网红", gender: "未知" },
  { name: "非诚勿扰", aliases: [], category: "网红", gender: "未知" },
  { name: "新相亲时代", aliases: [], category: "网红", gender: "未知" },
  { name: "心动的信号", aliases: [], category: "网红", gender: "未知" },
  { name: "我们恋爱吧", aliases: [], category: "网红", gender: "未知" },
  { name: "女儿们的恋爱", aliases: [], category: "网红", gender: "未知" },
  { name: "妻子的浪漫旅行", aliases: [], category: "网红", gender: "未知" },
  { name: "幸福三重奏", aliases: [], category: "网红", gender: "未知" },
  { name: "我家那闺女", aliases: [], category: "网红", gender: "未知" },
  { name: "我家那小子", aliases: [], category: "网红", gender: "未知" },
  { name: "婆婆和妈妈", aliases: [], category: "网红", gender: "未知" },
  { name: "新生日记", aliases: [], category: "网红", gender: "未知" },
  { name: "爸爸去哪儿", aliases: [], category: "网红", gender: "未知" },
  { name: "妈妈是超人", aliases: [], category: "网红", gender: "未知" },
  { name: "放开我北鼻", aliases: [], category: "网红", gender: "未知" },
  { name: "奇妙小森林", aliases: [], category: "网红", gender: "未知" },
  { name: "我们长大了", aliases: [], category: "网红", gender: "未知" },
  { name: "超新星全运会", aliases: [], category: "网红", gender: "未知" },
  { name: "运动吧少年", aliases: [], category: "网红", gender: "未知" },
  { name: "这就是灌篮", aliases: [], category: "网红", gender: "未知" },
  { name: "我要打篮球", aliases: [], category: "网红", gender: "未知" },
  { name: "这就是街舞", aliases: ["这街"], category: "网红", gender: "未知" },
  { name: "热血街舞团", aliases: [], category: "网红", gender: "未知" },
  { name: "舞蹈风暴", aliases: [], category: "网红", gender: "未知" },
  { name: "中国好舞蹈", aliases: [], category: "网红", gender: "未知" },
  { name: "武林争霸", aliases: [], category: "网红", gender: "未知" },
  { name: "笑傲江湖", aliases: [], category: "网红", gender: "未知" },
  { name: "欢乐喜剧人", aliases: [], category: "网红", gender: "未知" },
  { name: "喜剧总动员", aliases: [], category: "网红", gender: "未知" },
  { name: "跨界喜剧王", aliases: [], category: "网红", gender: "未知" },
  { name: "笑声传奇", aliases: [], category: "网红", gender: "未知" },
  { name: "吐槽大会", aliases: [], category: "网红", gender: "未知" },
  { name: "脱口秀大会", aliases: [], category: "网红", gender: "未知" },
  { name: "怎么办脱口秀专场", aliases: [], category: "网红", gender: "未知" },
  { name: "德云斗笑社", aliases: [], category: "网红", gender: "未知" },
  { name: "相声有新人", aliases: [], category: "网红", gender: "未知" },
  { name: "跨界歌王", aliases: [], category: "网红", gender: "未知" },
  { name: "跨界冰雪王", aliases: [], category: "网红", gender: "未知" },
  { name: "演员的诞生", aliases: [], category: "网红", gender: "未知" },
  { name: "我就是演员", aliases: [], category: "网红", gender: "未知" },
  { name: "演技派", aliases: [], category: "网红", gender: "未知" },
  { name: "演员请就位", aliases: [], category: "网红", gender: "未知" },
  { name: "导演请指教", aliases: [], category: "网红", gender: "未知" },
  { name: "开拍吧", aliases: [], category: "网红", gender: "未知" },
  { name: "光影中的演技派", aliases: [], category: "网红", gender: "未知" },
  { name: "声临其境", aliases: [], category: "网红", gender: "未知" },
  { name: "我是特优声", aliases: [], category: "网红", gender: "未知" },
  { name: "配音秀", aliases: [], category: "网红", gender: "未知" },
  { name: "奇葩说", aliases: [], category: "网红", gender: "未知" },
  { name: "黑白星球", aliases: [], category: "网红", gender: "未知" },
  { name: "超级演说家", aliases: [], category: "网红", gender: "未知" },
  { name: "我是演说家", aliases: [], category: "网红", gender: "未知" },
  { name: "精彩中国说", aliases: [], category: "网红", gender: "未知" },
  { name: "说出我世界", aliases: [], category: "网红", gender: "未知" },
  { name: "世界听我说", aliases: [], category: "网红", gender: "未知" },
  { name: "环球演说家", aliases: [], category: "网红", gender: "未知" },
  { name: "挑战不可能", aliases: [], category: "网红", gender: "未知" },
  { name: "了不起的挑战", aliases: [], category: "网红", gender: "未知" },
  { name: "我们的挑战", aliases: [], category: "网红", gender: "未知" },
  { name: "极限挑战", aliases: ["极挑"], category: "网红", gender: "未知" },
  { name: "奔跑吧", aliases: ["跑男"], category: "网红", gender: "未知" },
  { name: "快乐大本营", aliases: ["快本"], category: "网红", gender: "未知" },
  { name: "天天向上", aliases: [], category: "网红", gender: "未知" },
  { name: "你好星期六", aliases: [], category: "网红", gender: "未知" },
  { name: "王牌对王牌", aliases: [], category: "网红", gender: "未知" },
  { name: "青春环游记", aliases: [], category: "网红", gender: "未知" },
  { name: "萌探探探案", aliases: [], category: "网红", gender: "未知" },
  { name: "密室大逃脱", aliases: ["密逃"], category: "网红", gender: "未知" },
  { name: "明星大侦探", aliases: ["明侦"], category: "网红", gender: "未知" },
  { name: "大侦探", aliases: [], category: "网红", gender: "未知" },
  { name: "登录圆鱼洲", aliases: [], category: "网红", gender: "未知" },
  { name: "开始推理吧", aliases: [], category: "网红", gender: "未知" },
  { name: "女子推理社", aliases: [], category: "网红", gender: "未知" },
  { name: "森林进化论", aliases: [], category: "网红", gender: "未知" },
  { name: "名侦探学院", aliases: [], category: "网红", gender: "未知" },
  { name: "法医探案团", aliases: [], category: "网红", gender: "未知" },
  { name: "初入职场的我们", aliases: [], category: "网红", gender: "未知" },
  { name: "令人心动的offer", aliases: [], category: "网红", gender: "未知" },
  { name: "闪闪发光的你", aliases: [], category: "网红", gender: "未知" },
  { name: "职场是个技术活", aliases: [], category: "网红", gender: "未知" },
  { name: "高能实习生", aliases: [], category: "网红", gender: "未知" },
  { name: "主播有新人", aliases: [], category: "网红", gender: "未知" },
  { name: "主播请就位", aliases: [], category: "网红", gender: "未知" },
  { name: "嗨城市猎人", aliases: [], category: "网红", gender: "未知" },
  { name: "跃上高阶职场", aliases: [], category: "网红", gender: "未知" },
  { name: "100道光芒", aliases: [], category: "网红", gender: "未知" },
  { name: "求职高手", aliases: [], category: "网红", gender: "未知" },
  { name: "非你莫属", aliases: [], category: "网红", gender: "未知" },
  { name: "职来职往", aliases: [], category: "网红", gender: "未知" },
  { name: "创业中国人", aliases: [], category: "网红", gender: "未知" },
  { name: "合伙中国人", aliases: [], category: "网红", gender: "未知" },
  { name: "我是创始人", aliases: [], category: "网红", gender: "未知" },
  { name: " battling", aliases: [], category: "网红", gender: "未知" },
  { name: "创业时代", aliases: [], category: "网红", gender: "未知" },
  { name: "亲爱的客栈", aliases: [], category: "网红", gender: "未知" },
  { name: "中餐厅", aliases: [], category: "网红", gender: "未知" },
  { name: "向往的生活", aliases: [], category: "网红", gender: "未知" },
  { name: "五十公里桃花坞", aliases: [], category: "网红", gender: "未知" },
  { name: "花儿与少年", aliases: [], category: "网红", gender: "未知" },
  { name: "旅行任意门", aliases: [], category: "网红", gender: "未知" },
  { name: "青春的花路", aliases: [], category: "网红", gender: "未知" },
  { name: "少年可期", aliases: [], category: "网红", gender: "未知" },
  { name: "奇妙的朋友", aliases: [], category: "网红", gender: "未知" },
  { name: "神犬奇兵", aliases: [], category: "网红", gender: "未知" },
  { name: "真正的男子汉", aliases: [], category: "网红", gender: "未知" },
  { name: "火线英雄", aliases: [], category: "网红", gender: "未知" },
  { name: "我们的法则", aliases: [], category: "网红", gender: "未知" },
  { name: "跟着贝尔去冒险", aliases: [], category: "网红", gender: "未知" },
  { name: "越野千里", aliases: [], category: "网红", gender: "未知" },
  { name: "荒野求生", aliases: [], category: "网红", gender: "未知" },
  { name: " Survivor", aliases: [], category: "网红", gender: "未知" },
  { name: "幸存者", aliases: [], category: "网红", gender: "未知" },
  { name: "勇敢的世界", aliases: [], category: "网红", gender: "未知" },
  { name: "奇兵神犬", aliases: [], category: "网红", gender: "未知" },
  { name: "我们战斗吧", aliases: [], category: "网红", gender: "未知" },
  { name: "真心英雄", aliases: [], category: "网红", gender: "未知" },
  { name: "来吧冠军", aliases: [], category: "网红", gender: "未知" },
  { name: "运动不一样", aliases: [], category: "网红", gender: "未知" },
  { name: "冠军直通车", aliases: [], category: "网红", gender: "未知" },
  { name: "奥运健儿", aliases: [], category: "网红", gender: "未知" },
  { name: "国乒", aliases: [], category: "网红", gender: "未知" },
  { name: "国羽", aliases: [], category: "网红", gender: "未知" },
  { name: "中国女排", aliases: [], category: "网红", gender: "未知" },
  { name: "中国男排", aliases: [], category: "网红", gender: "未知" },
  { name: "中国女篮", aliases: [], category: "网红", gender: "未知" },
  { name: "中国男篮", aliases: [], category: "网红", gender: "未知" },
  { name: "中国女足", aliases: [], category: "网红", gender: "未知" },
  { name: "中国男足", aliases: [], category: "网红", gender: "未知" },
  { name: "国足", aliases: [], category: "网红", gender: "未知" },
];

const recentHotCelebrities: Celebrity[] = [
  { name: "白敬亭", aliases: ["小白"], category: "演员", gender: "男" },
  { name: "侯明昊", aliases: [], category: "演员", gender: "男" },
  { name: "丁禹兮", aliases: [], category: "演员", gender: "男" },
  { name: "曾舜晞", aliases: ["Joseph"], category: "演员", gender: "男" },
  { name: "张凌赫", aliases: [], category: "演员", gender: "男" },
  { name: "陈飞宇", aliases: [], category: "演员", gender: "男" },
  { name: "范丞丞", aliases: [], category: "演员", gender: "男" },
  { name: "王安宇", aliases: [], category: "演员", gender: "男" },
  { name: "林一", aliases: [], category: "演员", gender: "男" },
  { name: "周翊然", aliases: [], category: "演员", gender: "男" },
  { name: "田嘉瑞", aliases: [], category: "演员", gender: "男" },
  { name: "刘宇宁", aliases: ["摩登兄弟"], category: "歌手", gender: "男" },
  { name: "马嘉祺", aliases: ["小马"], category: "歌手", gender: "男" },
  { name: "丁程鑫", aliases: ["小丁"], category: "歌手", gender: "男" },
  { name: "宋亚轩", aliases: [], category: "歌手", gender: "男" },
  { name: "刘耀文", aliases: [], category: "歌手", gender: "男" },
  { name: "张真源", aliases: [], category: "歌手", gender: "男" },
  { name: "严浩翔", aliases: [], category: "歌手", gender: "男" },
  { name: "贺峻霖", aliases: [], category: "歌手", gender: "男" },
  { name: "时代少年团", aliases: ["TNT"], category: "歌手", gender: "男" },
  { name: "王楚然", aliases: [], category: "演员", gender: "女" },
  { name: "田曦薇", aliases: [], category: "演员", gender: "女" },
  { name: "周也", aliases: [], category: "演员", gender: "女" },
  { name: "宋祖儿", aliases: [], category: "演员", gender: "女" },
  { name: "张婧仪", aliases: [], category: "演员", gender: "女" },
  { name: "李兰迪", aliases: [], category: "演员", gender: "女" },
  { name: "章若楠", aliases: [], category: "演员", gender: "女" },
  { name: "卢昱晓", aliases: [], category: "演员", gender: "女" },
  { name: "向佐", aliases: [], category: "综艺人", gender: "男" },
  { name: "苏醒", aliases: [], category: "歌手", gender: "男" },
  { name: "张远", aliases: [], category: "歌手", gender: "男" },
  { name: "王栎鑫", aliases: [], category: "歌手", gender: "男" },
  { name: "陈楚生", aliases: [], category: "歌手", gender: "男" },
  { name: "陆虎", aliases: [], category: "歌手", gender: "男" },
  { name: "王铮亮", aliases: [], category: "歌手", gender: "男" },
  { name: "魏晨", aliases: [], category: "歌手", gender: "男" },
  { name: "黄龄", aliases: [], category: "歌手", gender: "女" },
  { name: "万妮达", aliases: ["Vinida"], category: "歌手", gender: "女" },
  { name: "单依纯", aliases: [], category: "歌手", gender: "女" },
  { name: "希林娜依高", aliases: [], category: "歌手", gender: "女" },
  { name: "林诗栋", aliases: [], category: "体育明星", gender: "男" },
  { name: "蒯曼", aliases: [], category: "体育明星", gender: "女" },
  { name: "亚马尔", aliases: ["Yamal", "Lamine Yamal"], category: "体育明星", gender: "男" },
  { name: "贝林厄姆", aliases: ["Bellingham", "Jude Bellingham"], category: "体育明星", gender: "男" },
  { name: "维尼修斯", aliases: ["Vinicius", "维尼修斯"], category: "体育明星", gender: "男" },
  { name: "Taylor Swift", aliases: ["泰勒斯威夫特", "霉霉", "泰勒"], category: "歌手", gender: "女" },
  { name: "BLACKPINK", aliases: ["粉墨"], category: "歌手", gender: "女" },
  { name: "Lisa", aliases: ["Lisa", "Lalisa"], category: "歌手", gender: "女" },
  { name: "Jennie", aliases: ["金珍妮"], category: "歌手", gender: "女" },
  { name: "BTS", aliases: ["防弹少年团"], category: "歌手", gender: "男" },
  { name: "NewJeans", aliases: ["新裤子女团"], category: "歌手", gender: "女" },
  // 2026-06 覆盖率核查补录:近7天高频但未识别的当红明星
  { name: "吴倩", aliases: [], category: "演员", gender: "女" },
  { name: "陈瑶", aliases: [], category: "演员", gender: "女" },
  { name: "杨坤", aliases: [], category: "歌手", gender: "男" },
  { name: "孙怡", aliases: [], category: "演员", gender: "女" },
  { name: "张月", aliases: [], category: "演员", gender: "女" },
  { name: "孙兴慜", aliases: ["孙球王"], category: "体育明星", gender: "男" },
];

const chinesePublicFigures: Celebrity[] = [
  { name: "陈道明", aliases: [], category: "演员", gender: "男" },
  { name: "陈宝国", aliases: [], category: "演员", gender: "男" },
  { name: "唐国强", aliases: [], category: "演员", gender: "男" },
  { name: "李雪健", aliases: [], category: "演员", gender: "男" },
  { name: "张国立", aliases: [], category: "演员", gender: "男" },
  { name: "王志文", aliases: [], category: "演员", gender: "男" },
  { name: "孙红雷", aliases: [], category: "演员", gender: "男" },
  { name: "张译", aliases: [], category: "演员", gender: "男" },
  { name: "张颂文", aliases: [], category: "演员", gender: "男" },
  { name: "秦昊", aliases: [], category: "演员", gender: "男" },
  { name: "王阳", aliases: [], category: "演员", gender: "男" },
  { name: "王骁", aliases: [], category: "演员", gender: "男" },
  { name: "郭京飞", aliases: [], category: "演员", gender: "男" },
  { name: "郭麒麟", aliases: [], category: "演员", gender: "男" },
  { name: "董子健", aliases: [], category: "演员", gender: "男" },
  { name: "尹正", aliases: [], category: "演员", gender: "男" },
  { name: "金世佳", aliases: [], category: "演员", gender: "男" },
  { name: "王传君", aliases: [], category: "演员", gender: "男" },
  { name: "张新成", aliases: [], category: "演员", gender: "男" },
  { name: "刘学义", aliases: [], category: "演员", gender: "男" },
  { name: "任嘉伦", aliases: [], category: "演员", gender: "男" },
  { name: "李宏毅", aliases: [], category: "演员", gender: "男" },
  { name: "敖瑞鹏", aliases: [], category: "演员", gender: "男" },
  { name: "丞磊", aliases: [], category: "演员", gender: "男" },
  { name: "王星越", aliases: [], category: "演员", gender: "男" },
  { name: "魏大勋", aliases: [], category: "演员", gender: "男" },
  { name: "杜江", aliases: [], category: "演员", gender: "男" },
  { name: "霍思燕", aliases: [], category: "演员", gender: "女" },
  { name: "殷桃", aliases: [], category: "演员", gender: "女" },
  { name: "秦海璐", aliases: [], category: "演员", gender: "女" },
  { name: "袁泉", aliases: [], category: "演员", gender: "女" },
  { name: "刘敏涛", aliases: [], category: "演员", gender: "女" },
  { name: "宋佳", aliases: ["小宋佳"], category: "演员", gender: "女" },
  { name: "马伊琍", aliases: [], category: "演员", gender: "女" },
  { name: "董洁", aliases: [], category: "演员", gender: "女" },
  { name: "陈数", aliases: [], category: "演员", gender: "女" },
  { name: "万茜", aliases: [], category: "演员", gender: "女" },
  { name: "辛芷蕾", aliases: [], category: "演员", gender: "女" },
  { name: "童瑶", aliases: [], category: "演员", gender: "女" },
  { name: "江疏影", aliases: [], category: "演员", gender: "女" },
  { name: "李一桐", aliases: [], category: "演员", gender: "女" },
  { name: "陈都灵", aliases: [], category: "演员", gender: "女" },
  { name: "孟子义", aliases: [], category: "演员", gender: "女" },
  { name: "李庚希", aliases: [], category: "演员", gender: "女" },
  { name: "任敏", aliases: [], category: "演员", gender: "女" },
  { name: "欧阳娜娜", aliases: [], category: "演员", gender: "女" },
  { name: "张予曦", aliases: [], category: "演员", gender: "女" },
  { name: "景甜", aliases: [], category: "演员", gender: "女" },
  { name: "舒淇", aliases: [], category: "演员", gender: "女" },
  { name: "林青霞", aliases: [], category: "演员", gender: "女" },
  { name: "张曼玉", aliases: [], category: "演员", gender: "女" },
  { name: "梅艳芳", aliases: [], category: "歌手", gender: "女" },
  { name: "张国荣", aliases: ["哥哥"], category: "歌手", gender: "男" },
  { name: "谭咏麟", aliases: ["校长"], category: "歌手", gender: "男" },
  { name: "张学友", aliases: ["歌神"], category: "歌手", gender: "男" },
  { name: "郭富城", aliases: [], category: "歌手", gender: "男" },
  { name: "黎明", aliases: [], category: "歌手", gender: "男" },
  { name: "许冠杰", aliases: [], category: "歌手", gender: "男" },
  { name: "李克勤", aliases: [], category: "歌手", gender: "男" },
  { name: "容祖儿", aliases: [], category: "歌手", gender: "女" },
  { name: "陈慧琳", aliases: [], category: "歌手", gender: "女" },
  { name: "莫文蔚", aliases: [], category: "歌手", gender: "女" },
  { name: "梁静茹", aliases: [], category: "歌手", gender: "女" },
  { name: "孙燕姿", aliases: [], category: "歌手", gender: "女" },
  { name: "林忆莲", aliases: [], category: "歌手", gender: "女" },
  { name: "陶喆", aliases: [], category: "歌手", gender: "男" },
  { name: "潘玮柏", aliases: [], category: "歌手", gender: "男" },
  { name: "罗志祥", aliases: ["小猪"], category: "歌手", gender: "男" },
  { name: "林宥嘉", aliases: [], category: "歌手", gender: "男" },
  { name: "萧敬腾", aliases: ["雨神"], category: "歌手", gender: "男" },
  { name: "胡彦斌", aliases: [], category: "歌手", gender: "男" },
  { name: "张碧晨", aliases: [], category: "歌手", gender: "女" },
  { name: "袁娅维", aliases: ["TIA"], category: "歌手", gender: "女" },
  { name: "吉克隽逸", aliases: [], category: "歌手", gender: "女" },
  { name: "尚雯婕", aliases: [], category: "歌手", gender: "女" },
  { name: "黄绮珊", aliases: [], category: "歌手", gender: "女" },
  { name: "萨顶顶", aliases: [], category: "歌手", gender: "女" },
  { name: "孟非", aliases: [], category: "主持人", gender: "男" },
  { name: "白岩松", aliases: [], category: "主持人", gender: "男" },
  { name: "鲁豫", aliases: ["陈鲁豫"], category: "主持人", gender: "女" },
  { name: "张绍刚", aliases: [], category: "主持人", gender: "男" },
  { name: "马东", aliases: [], category: "主持人", gender: "男" },
  { name: "窦文涛", aliases: [], category: "主持人", gender: "男" },
  { name: "易立竞", aliases: [], category: "主持人", gender: "女" },
  { name: "陈鲁豫", aliases: ["鲁豫"], category: "主持人", gender: "女" },
  { name: "刘强东", aliases: [], category: "其他", gender: "男" },
  { name: "马云", aliases: [], category: "其他", gender: "男" },
  { name: "马化腾", aliases: [], category: "其他", gender: "男" },
  { name: "雷军", aliases: [], category: "其他", gender: "男" },
  { name: "周鸿祎", aliases: [], category: "其他", gender: "男" },
  { name: "张朝阳", aliases: [], category: "其他", gender: "男" },
  { name: "俞敏洪", aliases: [], category: "其他", gender: "男" },
  { name: "董明珠", aliases: [], category: "其他", gender: "女" },
  { name: "宗馥莉", aliases: [], category: "其他", gender: "女" },
  { name: "罗翔", aliases: [], category: "其他", gender: "男" },
  { name: "于东来", aliases: [], category: "其他", gender: "男" },
  { name: "余承东", aliases: [], category: "其他", gender: "男" },
  { name: "苏炳添", aliases: [], category: "体育明星", gender: "男" },
  { name: "巩立姣", aliases: [], category: "体育明星", gender: "女" },
  { name: "吴艳妮", aliases: [], category: "体育明星", gender: "女" },
  { name: "郑钦文", aliases: [], category: "体育明星", gender: "女" },
  { name: "朱婷", aliases: [], category: "体育明星", gender: "女" },
  { name: "郎平", aliases: [], category: "体育明星", gender: "女" },
  { name: "易建联", aliases: ["阿联"], category: "体育明星", gender: "男" },
  { name: "郭艾伦", aliases: [], category: "体育明星", gender: "男" },
  { name: "周琦", aliases: [], category: "体育明星", gender: "男" },
  { name: "杨瀚森", aliases: [], category: "体育明星", gender: "男" },
  { name: "武磊", aliases: [], category: "体育明星", gender: "男" },
];

// 合并所有明星
export const CELEBRITIES: Celebrity[] = [
  ...singers,
  ...actors,
  ...varietyStars,
  ...athletes,
  ...directors,
  ...influencers,
  ...recentHotCelebrities,
  ...chinesePublicFigures,
];

// 构建明星名称到明星对象的映射
export const CELEBRITY_MAP: Map<string, Celebrity> = new Map();

CELEBRITIES.forEach((celebrity) => {
  // 添加主名称
  CELEBRITY_MAP.set(celebrity.name, celebrity);
  // 添加别名
  celebrity.aliases.forEach((alias) => {
    CELEBRITY_MAP.set(alias, celebrity);
  });
});

// 获取所有明星名称（用于匹配）
export function getAllCelebrityNames(): string[] {
  const names: string[] = [];
  CELEBRITIES.forEach((celebrity) => {
    names.push(celebrity.name);
    names.push(...celebrity.aliases);
  });
  return names;
}

// 从文本中识别明星(仅用主名匹配,别名不参与)
// 只返回真实人物(gender 不为 "未知"),综艺节目/团队等非人物排除
export function extractCelebritiesFromText(text: string): Celebrity[] {
  const foundCelebrities = new Set<Celebrity>();

  // 按名称长度降序排序，优先匹配长名称
  const sortedNames = CELEBRITIES
    .filter((c) => c.gender !== "未知") // 排除综艺节目/团队等非人物
    .map((c) => c.name)
    .sort((a, b) => b.length - a.length);

  for (const name of sortedNames) {
    if (text.includes(name)) {
      const celebrity = CELEBRITY_MAP.get(name);
      if (celebrity && celebrity.gender !== "未知") {
        foundCelebrities.add(celebrity);
      }
    }
  }

  return Array.from(foundCelebrities);
}

// 根据明星名称获取明星信息
export function getCelebrityByName(name: string): Celebrity | undefined {
  return CELEBRITY_MAP.get(name);
}

// 生成百度百科词条链接(纯函数,无需落库)
// 规则: https://baike.baidu.com/item/{name}
// 注: 部分名人可能 404 或跳消歧义页,作为外链可接受
export function getCelebrityBaikeUrl(name: string): string {
  return `https://baike.baidu.com/item/${encodeURIComponent(name.trim())}`;
}

// 按类别分组的明星
export function getCelebritiesByCategory(): Map<string, Celebrity[]> {
  const map = new Map<string, Celebrity[]>();
  CELEBRITIES.forEach((celebrity) => {
    const list = map.get(celebrity.category) || [];
    list.push(celebrity);
    map.set(celebrity.category, list);
  });
  return map;
}

// 按性别分组的明星
export function getCelebritiesByGender(): Map<string, Celebrity[]> {
  const map = new Map<string, Celebrity[]>();
  CELEBRITIES.forEach((celebrity) => {
    const list = map.get(celebrity.gender) || [];
    list.push(celebrity);
    map.set(celebrity.gender, list);
  });
  return map;
}
